import { render, staticRenderFns } from "./UserGradeApprovalAll.vue?vue&type=template&id=b7adc700&scoped=true"
import script from "./UserGradeApprovalAll.vue?vue&type=script&lang=js"
export * from "./UserGradeApprovalAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7adc700",
  null
  
)

export default component.exports